import React from "react";
import logo from "../../images/wespta-ski-logo-min.png";

export default function DashboardHeader({ title = "Waitsfield Ski & Skate Sale", onSignOut }) {
  return (
    <div className="brand" style={{ justifyContent: "space-between" }}>
      <div style={{ display: "flex", alignItems: "center" }}>
        <img src={logo} alt="Waitsfield Ski & Skate Sale logo" />
        <p className="has-text-weight-semibold">
          {title}
          <br />
        </p>
      </div>
      <button className="button is-danger is-small" onClick={onSignOut}>
        Sign out
      </button>
    </div>
  );
}
